import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';
import { FA_SELECTOR } from '../../styles/variables';

export const useDateElementsStyles = createStyles(({ css, token }) => ({
  datePreviewIcon: css`
    color: ${token.colorPrimary};
    margin-left: 0;
    font-size: 18px;
    margin-right: ${ThemeSpaces.SPACE_SM}px;

    @media (max-width: ${token.screenSMMax}px) {
      font-size: 16px;
      margin-right: ${ThemeSpaces.SPACE_XS}px;
    }
  `,
  suffixAsPrefix: css`
    .ant-picker-input {
      flex-direction: row-reverse;

      .ant-picker-suffix {
        margin-left: ${ThemeSpaces.SPACE_NORM}px;
        margin-right: ${ThemeSpaces.SPACE_NORM - token.paddingSM}px;

        @media (max-width: ${token.screenXSMax}px) {
          margin-left: ${ThemeSpaces.SPACE_NORM0_5}px;
          margin-right: ${ThemeSpaces.SPACE_NORM0_5 - token.paddingSM}px;
        }

        > * {
          display: block;
          margin-right: 0;
        }
      }
    }
  `,
  dateRangePreview: css`
    & > .ant-col *:nth-child(2),
    & > .ant-col *:nth-child(3) {
      margin-right: ${ThemeSpaces.SPACE_XS}px;

      @media (max-width: ${token.screenSMMax}px) {
        margin-right: ${ThemeSpaces.SPACE_XXS}px;
      }
    }

    @media (max-width: ${token.screenSMMax}px) {
      font-size: ${ThemeFont.FONT_SIZE_SM_PLUS}px;
    }

    .ant-btn {
      height: 32px;
    }
  `,
  dateRangeDash: css`
    font-weight: 500;
    margin: 0 ${ThemeSpaces.SPACE_XXS}px;
    font-size: ${ThemeFont.FONT_SIZE_SM_PLUS}px;

    @media (max-width: ${token.screenSMMax}px) {
      font-size: ${token.fontSizeSM}px;
    }
  `,
  dateRangeContainer: css`
    ${FA_SELECTOR} {
      font-size: 21px;
    }

    &,
    & .ant-form-item-label label,
    & .ant-form-item {
      color: ${ThemeColors.COLOR_GREY_BLUISH};
    }

    .ant-form-item {
      margin-bottom: 0;

      .ant-form-item-label label {
        text-transform: uppercase;
        height: 16px;
        line-height: 16px;
        margin-bottom: ${ThemeSpaces.SPACE_XS}px;
        font-size: ${ThemeFont.FONT_SIZE_XS}px;
      }

      .ant-picker {
        height: 24px;

        .ant-picker-input input {
          font-size: ${ThemeFont.FONT_SIZE_SM_PLUS}px;
          padding: 0 ${ThemeSpaces.SPACE_XS}px;
          text-align: center;
        }
      }
    }
  `,
  dateRangePresetButton: css`
    display: block;
    width: 100%;
    margin: ${ThemeSpaces.SPACE_MD}px 0;
  `,
  dateTimePicker: css`
    display: flex;

    .Col-DatePicker {
      @media (min-width: ${token.screenMDMin}px) {
        width: 160px;
        margin-right: ${ThemeSpaces.SPACE_NORM_20}px;
      }
      @media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px) {
        width: 150px;
        margin-right: ${ThemeSpaces.SPACE_NORM}px;
      }
      @media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenSMMax}px) {
        width: 125px;
        margin-right: ${ThemeSpaces.SPACE_NORM}px;
      }
      @media (max-width: ${token.screenXSMax}px) {
        width: 105px;
        margin-right: ${ThemeSpaces.SPACE_NORM}px;
      }

      .ant-picker-input input {
        @media (max-width: ${token.screenLGMin}px) {
          font-size: 14px;
        }
      }
    }

    .Col-TimePicker {
      @media (min-width: ${token.screenMDMin}px) {
        width: 120px;
      }
      @media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenSMMax}px) {
        width: 90px;
      }
      @media (max-width: ${token.screenXSMax}px) {
        width: 80px;
      }
    }

    &.expand-size {
      .Col-DatePicker {
        width: initial;
        flex: 3;
        min-width: 0;

        @media (min-width: ${token.screenMDMin}px) {
          margin-right: ${ThemeSpaces.SPACE_NORM_20}px;
        }
        @media (max-width: ${token.screenSMMax}px) {
          margin-right: ${ThemeSpaces.SPACE_NORM}px;
        }
      }

      .Col-TimePicker {
        width: initial;
        flex: 2;
        min-width: 0;
      }
    }
  `,
  validationGroup: css`
    @media (min-width: ${token.screenMDMin}px) {
      width: ${200 + ThemeSpaces.SPACE_MD}px;
    }
    @media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenSMMax}px) {
      width: ${186 + ThemeSpaces.SPACE_NORM}px;
    }
    @media (max-width: ${token.screenXSMax}px) {
      width: ${182 + ThemeSpaces.SPACE_NORM}px;
    }
  `,
  allowPointerEvents: css`
    .ant-picker-cell-disabled {
      pointer-events: auto !important;
    }
  `,
  footerButton: css`
    color: ${ThemeColors.COLOR_RED};
    text-align: center;
    cursor: pointer;
    border-bottom: 1px solid ${ThemeColors.COLOR_WHITE4};

    &:last-child {
      border-bottom-width: 0;
    }
  `,
  timePickerWithNow: css`
    .ant-picker-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 2px 8px;

      .ant-picker-footer-extra {
        display: inline;
        border-bottom: none;
      }

      .ant-picker-ranges {
        display: inline;
        padding: 0;
      }
    }
  `,
}));
